<div class="card-base">
    <div class="card-content-study-report-search">
        <div class="chip-container">
            <mat-chip-list>
                <mat-chip color="accent" matTooltip="{{filt.toolTip}}" selected *ngFor="let filt of searchFilters">
                    {{ filt.valueView }}
                    <mat-icon *ngIf="!filt.isRequired" (click)="filt.remove()">cancel</mat-icon>
                </mat-chip>
            </mat-chip-list>

        </div>
        <div class="card-container mat-elevation-z1">
            <div class="clearfix">
                <div class="pull-right div-header-right">

                    <button class="card-inline margin-top-medium" [matMenuTriggerFor]="columnsMenu" type="button" mat-mini-fab matTooltip="Columnas visibles">
                        <mat-icon>view_column</mat-icon>
                    </button>

                    <mat-menu #columnsMenu="matMenu" class="columns-menu">
                        <button mat-menu-item (click)="showAllColumns()">
                            <span>Mostrar todas</span>
                        </button>
                        <mat-divider></mat-divider>
                        <div class="columns-menu-item" *ngFor="let col of availableColumns" (click)="$event.stopPropagation()">
                            <mat-checkbox [checked]="isColumnVisible(col.field)" (click)="$event.stopPropagation()" (change)="setColumnVisibility(col.field, $event.checked)">
                                {{ col.title }}
                            </mat-checkbox>
                        </div>
                    </mat-menu>

                    <button class="card-inline margin-top-medium" [matMenuTriggerFor]="actionsMenu" type="button" mat-mini-fab>
                        <mat-icon>more_vert</mat-icon>
                    </button>

                    <mat-menu #actionsMenu="matMenu">
                        <button (click)="exportCsv()" mat-menu-item>
                            <span> <b>Exportar a csv</b></span>
                        </button>
                    </mat-menu>
                </div>
                <div class="pull-left div-header-left">
                    <app-search-filter-component #searchFilter (startSearch)="onStartSearch()" (endSearch)="onEndSearch($event)" [filter]="filters"></app-search-filter-component>
                    <app-billing-invoice-credit-filter #filters></app-billing-invoice-credit-filter>
                </div>
            </div>
            <mat-divider></mat-divider>
            <div class="card-content margin-botton-medium">
                <div class="grid-scroll-container">
                    <p-table class="search-table" [value]="dataSource" [tableStyle]="{ width: '100%' }">
                        <ng-template pTemplate="header">
                            <tr class="search-table-header">
                                <th class="resizable-header" *ngFor="let col of orderedColumnsDefinition" [style.width.px]="getColumnWidth(col.field)" (dragover)="onHeaderDragOver($event)" (drop)="onHeaderDrop($event, col.field)">
                                    <div class="header-top-row">
                                        <span class="header-drag-content">
                                            <span class="column-title" (click)="sortByColumn(col.field)">
                                                {{ col.title }}
                                                <mat-icon class="sort-icon">{{ getSortIcon(col.field) }}</mat-icon>
                                            </span>
                                        <mat-icon class="header-drag-handle" draggable="true" (dragstart)="onHeaderDragStart($event, col.field)" (dragend)="onHeaderDragEnd()" (click)="$event.stopPropagation()">drag_indicator</mat-icon>
                                        </span>
                                        <span class="column-resize-handle" (mousedown)="startResize($event, col.field)"></span>
                                    </div>
                                    <input class="column-filter-input" [value]="columnFilters[col.field] || ''" (click)="$event.stopPropagation()" (input)="onColumnFilterInput(col.field, $event.target.value)" placeholder="Filtrar" />
                                </th>
                                <th class="actions-column"></th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-element>
                            <tr class="search-table-cell">
                                <td *ngFor="let col of orderedColumnsDefinition" [style.width.px]="getColumnWidth(col.field)">
                                    <ng-container [ngSwitch]="col.field">
                                        <span *ngSwitchCase="'invoiceNumber'"><b>{{ element.InvoiceNumberComplete }}</b></span>
                                        <span *ngSwitchCase="'erpCode'">{{ element.ErpCode }}</span>
                                        <span *ngSwitchCase="'invoiceDate'">{{ element.InvoiceDate | date:'dd/MM/yyyy' }}</span>
                                        <span *ngSwitchCase="'amount'">{{ element.Amount }}</span>
                                        <span *ngSwitchCase="'alicuotsColumn'">{{ element.AlicuotsColumn }}</span>
                                        <span *ngSwitchCase="'billingGroupName'">{{ element.BillingGroupName }}</span>
                                        <span *ngSwitchCase="'billingGroupFrom'">{{ element.BillingGroupFrom | date:'dd/MM/yyyy' }}</span>
                                        <span *ngSwitchCase="'billingGroupTo'">{{ element.BillingGroupTo | date:'dd/MM/yyyy' }}</span>
                                        <span *ngSwitchCase="'billingGroupNumber'">{{ element.BillingGroupNumber }}</span>
                                    </ng-container>
                                </td>
                                <td class="actions-column">
                                    <mat-spinner *ngIf="element.Loading" [diameter]="15"></mat-spinner>
                                    <button mat-icon-button *ngIf="!element.Loading" [matMenuTriggerFor]="rowMenu">
                                        <mat-icon>more_vert</mat-icon>
                                    </button>
                                    <mat-menu #rowMenu="matMenu">
                                        <button (click)="viewReport(element)" mat-menu-item>
                                            <mat-icon>search</mat-icon><span>Ver</span>
                                        </button>
                                        <button *ngIf="!element.HasCreditNote && !element.IsCredit" (click)="redirectCreateInvoiceCredit(element)" mat-menu-item>
                                            <mat-icon>edit</mat-icon><span>Generar nota de crédito</span>
                                        </button>

                                        <button (click)="sendInvoiceMail(element)" mat-menu-item>
                                            <mat-icon>mail</mat-icon><span>Enviar por mail</span>
                                        </button>

                                        <button (click)="viewBillingReport(element)" mat-menu-item>
                                            <mat-icon>search</mat-icon><span>Rendición</span>
                                        </button>
                                        <button *ngIf="!element.IsCredit" (click)="exportBilling(element)" mat-menu-item>
                                            <mat-icon>search</mat-icon><span>Exportar</span>
                                        </button>

                                        <button *ngIf="!element.IsCredit" (click)="exportExcelBilling(element)" mat-menu-item>
                                            <mat-icon>search</mat-icon><span>Exportar excel</span>
                                        </button>

                                        <button (click)="openLogViewDialog(element)" mat-menu-item>
                                            <mat-icon>search</mat-icon><span>Actividades</span>
                                        </button>

                                        <button (click)="exportStudyReport(element)" mat-menu-item>
                                            <mat-icon>alarm_add</mat-icon><span>Preparar descarga de informes…</span>
                                        </button>
                                        <button (click)="exportImages(element)" mat-menu-item>
                                            <mat-icon>alarm_add</mat-icon><span>Preparar descarga de imágenes…</span>
                                        </button>
                                    </mat-menu>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
                <pager [exportColumns]="exportColumns" [exportColumnsName]="exportColumnsName" (selectedPageIndexChange)="selectedPageIndexChange($event)" #pager></pager>
            </div>
        </div>
    </div>
</div>
